import { asyncApiCall } from '../utils/services';
import { developmentAppConfig } from '../development.appConfig';
export class ConfigServices {
    apiUrl;

    constructor(apiUrl) {
        this.apiUrl = apiUrl;
    }

    getApplicationAppConfig = async (configurationKey: string = 'default') =>
        asyncApiCall(
            `${this.apiUrl}/services/getApplicationAppConfig/${configurationKey}`,
            {
                method: 'GET',
            }
        );

    getConfigFile = async () => {
        if (process.env.NODE_ENV === 'development') {
            return developmentAppConfig;
        }
        return asyncApiCall(`${this.apiUrl}/appConfig.json`, { method: 'GET' });
    };

    getLocaleFile = async locale =>
        asyncApiCall(`${this.apiUrl}/${locale}.json`, { method: 'GET' });
}



// WEBPACK FOOTER //
// ./src/services/configServices.ts